import React from 'react';
// import { Carousel } from 'react-bootstrap';
// import banner1 from '../../../images/banner pic/ban1.jpg';
// import banner2 from '../../../images/banner pic/ban2.jpg';
// import banner3 from '../../../images/banner pic/ban3.jpg';
import backimg from '../../../images/IMG_20211031_155241.jpg';
import './Banner.css';


const Banner = () => {
    return (
        <>
        
       <img src={backimg} alt="" className="img-fluid menu-icon"/>
      
          
<div className="header mt-5">
    <h3>About Tourism Management System</h3>
    <p> Tourism Management System aims to increase the awarness of tourists attractions,to encourage and support travel to Tourism Management System.This system connects customers and agents directly, provides a feedback mechanism for tourists, maintains and controls the database of tourists' information, and gives a variety of travel services. </p>
    <h3>Our vision</h3>
    <p>The user needs to visit the travel agency office to plan any tour. It involves a lot of manual paperwork, and customers need to stay in the queue for a long time. The present systems are inadequate in providing information and advice to the agencies and customers about tour plans. Most of the time agencies have to rely on local information sources and their own experience regarding time and cost. Through a phone call, they have to get information. </p>
    <h3>Our Mission</h3>
    <p>Our Tourism Management System has the following advantages over the traditional system:

1.Privacy and Confidentiality
2.Effective during emergency conditions.
3.It saves time and effort.
4.Easy updation of records</p>
<h3>Safety Information</h3>
<p>Vacation is a time to relax in safe surroundings.For Emergency aid of any kind,call 911 from any phone...in your hotel.</p>
<h3>Transportation Safety Tips</h3>
<p>Unwary tourists can make easy targets for thieves because they stand out in a crowd, are unused to their surroundings, and are generally carrying money, credit cards and valuables like cameras. You can reduce your risk of being mugged or robbed by taking a few simple precautions. It is a good idea to research the safety of your intended destination with the Department of Foreign Affairs and Trade. This government department keeps an updated bulletin on travel destinations, covering factors such as political unrest or criminal activities that target tourists. You could also consult with your travel agent, or talk to friends who have already visited your intended destination.</p>
<h3>Hotel Safety Tips</h3>
<p>For some travelers, a hotel’s a place to rest their head after a day of exploring. For others, it’s where they decompress after a long day of meetings. However a guest might see their accommodations, a hotel serves as a home away from home — and it should feel like that in more ways than one.

Namely, guests look for comfort — especially from the cozy rooms and extra amenities you provide. They also want to feel just as secure with you as they do in their own homes. Indeed, that’s why safety is one of the fundamental basics that every hotel should provide.

It’s up to you to make sure your hotel has safety measures in place that make guests feel protected while they stay with you. </p>
<h3>Welcome Our System</h3>
<p>We are providing you best and best services and Resort</p>

</div>

        </>
    );
};

export default Banner;